var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5--\\u0421\\u041C\\u041F--|---Web-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-04-\\u0421\\u041C\\u041F-|-\\u043D\\u043E\\u0432\\u0430\\u044F-\\u0437\\u0430\\u044F\\u0432\\u043A\\u0430-|-\\u0421\\u041A-\\u0436\\u0434\\u0435\\u0442-\\u043F\\u043E\\u0434\\u0442\\u0432\\u0435\\u0440\\u0436\\u0434\\u0435\\u043D\\u0438\\u044F",
    transform: "translate(-1354.000000, -246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "column_requests",
    transform: "translate(1038.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1F6FF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cards/\\u0412-\\u0418\\u0441\\u043F\\u043E\\u043B\\u043D\\u0435\\u043D\\u0438\\u0438/\\u0412-\\u043F\\u0443\\u0442\\u0438",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PayCard"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#EBF0F9",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 339,
    height: 113,
    rx: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "status",
    transform: "translate(0.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 340,
    height: 48
  })), /*#__PURE__*/React.createElement("g", {
    id: "info-card",
    transform: "translate(12.000000, 8.000000)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(820.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "offer-1",
    transform: "translate(40.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/misc/trash",
    transform: "translate(494.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3846154,12.7142857 L20.3846154,21.2857143 C20.3846154,22.2308571 19.6598462,23 18.7692308,23 L18.7692308,23 L11.2307692,23 C10.3401538,23 9.61538462,22.2308571 9.61538462,21.2857143 L9.61538462,21.2857143 L9.61538462,12.7142857 L20.3846154,12.7142857 Z M12.3076923,14.4285714 C12.0104615,14.4285714 11.7692308,14.6845714 11.7692308,15 L11.7692308,15 L11.7692308,20.1428571 C11.7692308,20.4582857 12.0104615,20.7142857 12.3076923,20.7142857 C12.6049231,20.7142857 12.8461538,20.4582857 12.8461538,20.1428571 L12.8461538,20.1428571 L12.8461538,15 C12.8461538,14.6845714 12.6049231,14.4285714 12.3076923,14.4285714 Z M15,14.4285714 C14.7027692,14.4285714 14.4615385,14.6845714 14.4615385,15 L14.4615385,15 L14.4615385,20.1428571 C14.4615385,20.4582857 14.7027692,20.7142857 15,20.7142857 C15.2972308,20.7142857 15.5384615,20.4582857 15.5384615,20.1428571 L15.5384615,20.1428571 L15.5384615,15 C15.5384615,14.6845714 15.2972308,14.4285714 15,14.4285714 Z M17.6923077,14.4285714 C17.3950769,14.4285714 17.1538462,14.6845714 17.1538462,15 L17.1538462,15 L17.1538462,20.1428571 C17.1538462,20.4582857 17.3950769,20.7142857 17.6923077,20.7142857 C17.9895385,20.7142857 18.2307692,20.4582857 18.2307692,20.1428571 L18.2307692,20.1428571 L18.2307692,15 C18.2307692,14.6845714 17.9895385,14.4285714 17.6923077,14.4285714 Z M16.0769231,7 C16.9675385,7 17.6923077,7.76914286 17.6923077,8.71428571 L17.6923077,8.71428571 L17.6923077,9.28571429 L20.9230769,9.28571429 C21.517,9.28571429 22,9.79828571 22,10.4285714 L22,10.4285714 L22,11 C22,11.3154286 21.7587692,11.5714286 21.4615385,11.5714286 L21.4615385,11.5714286 L8.53846154,11.5714286 C8.24123077,11.5714286 8,11.3154286 8,11 L8,11 L8,10.4285714 C8,9.79828571 8.483,9.28571429 9.07692308,9.28571429 L9.07692308,9.28571429 L12.3076923,9.28571429 L12.3076923,8.71428571 C12.3076923,7.76914286 13.0324615,7 13.9230769,7 L13.9230769,7 Z M16.0769231,8.14285714 L13.9230769,8.14285714 C13.6263846,8.14285714 13.3846154,8.39942857 13.3846154,8.71428571 L13.3846154,8.71428571 L13.3846154,9.28571429 L16.6153846,9.28571429 L16.6153846,8.71428571 C16.6153846,8.39942857 16.3736154,8.14285714 16.0769231,8.14285714 L16.0769231,8.14285714 Z",
    id: "Combined-Shape",
    fill: "#636F77"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1b24d6fd.svg";
export { ForwardRef as ReactComponent };